import React from 'react';
import dynamic from 'next/dynamic';
import {
  Footer, ThemeProvider, darkTheme,
// eslint-disable-next-line import/no-unresolved
} from '@binance/uikit';
import { connect } from 'react-redux';

import withI18n from '../../utils/withI18n';
import { formatNumber } from '../../utils/number';


const RecentMarketBar = dynamic(import('../RecentMarketBar'), {
  ssr: false,
  loading: () => null,
});


type Props = {
  locale: String,
  withRecentMarketBar: Boolean,
  tickers: Object,
  omitFooterTotalUpdate: Boolean,
  isLoggedIn: Boolean,
}

const mapStateToProps = ({
  isLoggedIn,
  tickers,
}) => ({
  isLoggedIn,
  tickers,
});

export default
@withI18n
@connect(mapStateToProps)
class FooterComponent extends React.Component<Props> {
  constructor(props) {
    super(props);
    this.state = {};
  }

  getVolumes = () => {
    const { tickers, omitFooterTotalUpdate } = this.props;
    if (omitFooterTotalUpdate) return [];

    const totalVolumes = {};
    Object.values(tickers).forEach((el) => {
      const key = el.pn === 'ALTS' ? el.qa : el.pn;
      if (!totalVolumes[key]) totalVolumes[key] = 0;
      totalVolumes[key] += parseFloat(el.q);
    });

    const list = Object.keys(totalVolumes).map((key) => ({
      market: key,
      total: formatNumber(totalVolumes[key], 2),
    }));

    return list;
  }

  render() {
    const {
      locale, withRecentMarketBar, isLoggedIn,
    } = this.props;

    return (
      <>
        { withRecentMarketBar && <RecentMarketBar /> }
        <ThemeProvider theme={darkTheme}>
          <Footer
            locale={locale}
            volumes={this.getVolumes()}
            isLoggedIn={isLoggedIn}
            useGoogleTranslator={false}
          />
        </ThemeProvider>
      </>
    );
  }
}
